import React, { useState } from "react";
import { Radio, Compass, ListChecks, X } from "lucide-react";

export default function WelcomeModal({ firstName, onAction }) {
  const [dontShow, setDontShow] = useState(false);

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center p-4" data-testid="tour-welcome-modal">
      <div className="absolute inset-0 bg-black/75 backdrop-blur-sm" />
      <div className="relative w-full max-w-lg rounded-2xl border border-line bg-bg-surface p-8 shadow-2xl animate-fade-up">
        <button onClick={() => onAction("skip", dontShow)} data-testid="tour-welcome-close"
          className="absolute right-4 top-4 text-ink-muted hover:text-ink-primary transition"><X className="h-4 w-4" /></button>
        <div className="flex items-center gap-3 mb-5">
          <div className="h-12 w-12 rounded-xl bg-brand-amber/15 border border-brand-amber/40 flex items-center justify-center">
            <Radio className="h-6 w-6 text-brand-amber" />
          </div>
          <div>
            <h2 className="font-display text-2xl font-bold text-ink-primary">Welcome to BroadcastFlow AI</h2>
            <p className="text-sm text-ink-secondary">Let's get your workspace set up and show you around{firstName && firstName !== "there" ? `, ${firstName}` : ""}.</p>
          </div>
        </div>
        <div className="space-y-2.5">
          <button onClick={() => onAction("tour", dontShow)} data-testid="tour-welcome-start"
            className="w-full inline-flex items-center gap-3 rounded-xl bg-brand-amber px-5 py-3.5 text-sm font-bold text-black hover:bg-brand-amber/90 transition">
            <Compass className="h-4 w-4" /> Start Guided Tour
          </button>
          <button onClick={() => onAction("goals", dontShow)} data-testid="tour-welcome-goals"
            className="w-full inline-flex items-center gap-3 rounded-xl border border-line bg-bg-elevated px-5 py-3.5 text-sm font-bold text-ink-primary hover:border-brand-amber/50 transition">
            <ListChecks className="h-4 w-4 text-brand-cyan" /> Choose What I Want to Set Up
          </button>
          <button onClick={() => onAction("skip", dontShow)} data-testid="tour-welcome-skip"
            className="w-full rounded-xl px-5 py-2.5 text-xs font-semibold text-ink-muted hover:text-ink-primary transition">
            Skip for Now
          </button>
        </div>
        <label className="mt-4 flex items-center gap-2 text-[11px] text-ink-muted cursor-pointer">
          <input type="checkbox" checked={dontShow} onChange={(e) => setDontShow(e.target.checked)}
            data-testid="tour-welcome-dontshow" />
          Don't automatically show this again
        </label>
        <p className="mt-2 text-[10px] text-ink-muted">You can restart the tour anytime from Help → Getting Started.</p>
      </div>
    </div>
  );
}
